import { render, staticRenderFns } from "./StepItem.vue?vue&type=template&id=46552c5e&scoped=true"
import script from "./StepItem.vue?vue&type=script&lang=js"
export * from "./StepItem.vue?vue&type=script&lang=js"
import style0 from "./StepItem.vue?vue&type=style&index=0&id=46552c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46552c5e",
  null
  
)

export default component.exports